


















































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { IDRec, ChoiceOption } from '@/interfaces';

@Component
export default class SiteTypeDetail extends Mixins(DetailMixin) {
  public items: IDRec[] = [];
  public tableCfg = FieldDefs;

  public headers = [
    {
      text: 'Naam',
      value: 'name'
    },
    {
      text: 'Type',
      value: 'linedatatype'
    },
    {
      text: 'Standaard',
      value: 'default'
    },
    {
      text: 'Titel NL',
      value: 'title_nl'
    },
    {
      text: 'Titel FR',
      value: 'title_fr'
    },
    {
      text: 'Items NL Count',
      value: 'values_cnt_nl'
    },
    {
      text: 'Items FR Count',
      value: 'values_cnt_fr'
    }
  ];

  public get isNew() {
    return this.$route.params.id === 'new';
  }

  public goToNewSiteTypeLine() {
    const siteTypeId = this.$route.params.id;
    this.$router.push(
      this.getTableCfg(this.tableCfg, 'url') + '/' + siteTypeId + '/lines/new'
    );
  }

  public get getSiteTypeLineLink() {
    const siteTypeId = this.$route.params.id;
    return (
      this.getTableCfg(this.tableCfg, 'url') + '/' + siteTypeId + '/lines/'
    );
  }

  public async getSiteTypeLines() {
    const id = this.$route.params.id;
    const response = await this.api.getLines(this.$store, '/sitetypes/' + id);
    if (response) {
      const items = response.data.data;
      this.items = items;
    }
  }

  public async SiteTypeLinesChange(moved) {
    const id = this.$route.params.id;
    const order: number[] = [];
    for (const item of this.items) {
      order.push(item.id);
    }
    const response = await this.api.createRecord(
      this.$store,
      '/sitetypes/' + id + '/lines/set_order',
      {
        idlist: order
      }
    );
  }

  public async SiteTypeLinesDelete(deletedId) {
    const id = this.$route.params.id;
    const response = await this.api.deleteRecord(
      this.$store,
      '/sitetypes/' + id + '/lines/' + String(deletedId)
    );
  }

  // Lifecycle Functions
  public created() {
    if (!this.isNew) {
      this.getSiteTypeLines();
    }
  }
}
